/** @module search/components */

import React from "react";
import PropTypes from 'prop-types';
import R from "ramda";
import classNames from "classnames";
import Select from "react-select";
import Async from "react-select/lib/Async.js";
import { GetIcon } from "../icons/GetIcon.js";

class TypeaheadFacet extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      focused: false
    };
  }

  onBlur = () => {
    this.setState({
      focused: false
    });
  }

  onFocus = () => {
    this.setState({
      focused: true
    });
  }

  onFacetChange = (value) => {
    const { selectedFacets, values } = this.props;

    let localSelected = values.reduce((accum, value) => {
      if (selectedFacets.indexOf(value.id) > -1) {
        accum.push(value.id);
      }
      return accum;
    }, []);

    let valueIdsOnly = Array.isArray(value)
      ? value.map((v) => v.id)
      : [value.id];

    let difference = localSelected
      .filter(x => valueIdsOnly.indexOf(x) === -1)
      .concat(valueIdsOnly.filter(x => localSelected.indexOf(x) === -1));

    difference.map((facetId) => {
      this.props.handleFacetChange(facetId, localSelected.indexOf(facetId) === -1);
    });
  }

	renderValue = (option) => {
		return option.smalltext
      ? <span><span>{ option.label }</span><span>{ option.smalltext }</span></span>
      : <span>{ option.label }</span>;
  }

  loadOptions = (value, callback) => {
    const { endpoint, id } = this.props;

    fetch(endpoint + "?filterType=" + id + "&term=" + value)
      .then((response) => {
          return response.json()
      })
      .then((json) =>
       {
        const requestResults = json.values.map((value) => {
          value.value = value.id;
          value.label = value.name;
          return value;
        });

        callback(requestResults);
       });
  }

  render() {
    const { endpoint, id, label, selectedFacets, values } = this.props;
    const { focused } = this.state;

    const reactSelectValues = values.map((value) => {
      value.value = value.id;
      value.label = value.name;
      return value;
    });

    const lastYear = (new Date().getFullYear() - 1).toString();

    if (id == 'year') {
      reactSelectValues.sort((a, b) => a.name - b.name);
      for (let i = 0; i < reactSelectValues.length; i++) {
        if (reactSelectValues[i].name == lastYear) {
          reactSelectValues.sort((a, b) => b.name - a.name);
          break;
        }
      }
    }
    
    const selected = reactSelectValues.filter((value) => {
      return selectedFacets.indexOf(value.value) > -1;
    });

    const multi = true;
    const clearable = true;
    const inputID = "input-" + id;

    const fieldClass = classNames("form__field form__field--placeholder", {
      "is-dirty": focused
    });

    return (
      <div className="facets__input">
        <div className={ fieldClass }>
        <label id={ id } htmlFor={ inputID }>{ label }</label>
        {!endpoint && <Select
          isMulti={ multi }
          value={ selected }
          onChange={ this.onFacetChange }
          onFocus={ this.onFocus }
          onBlur={ this.onBlur }
          options={ reactSelectValues }
          hideSelectedOptions={ false }
          inputId={ inputID }
          isClearable={ clearable }
          classNamePrefix="typeahead"
          backspaceRemovesValue={ false }
          maxMenuHeight={200}
          placeholder=""
          aria-labelledby={ id }
          formatOptionLabel={ this.renderValue } />}
        {endpoint && <Async
          isMulti={ multi }
          value={ selected }
          onChange={ this.onFacetChange }
          onFocus={ this.onFocus }
          onBlur={ this.onBlur }
          defaultOptions={ reactSelectValues }
          hideSelectedOptions={ false }
          inputId={ inputID }
          isClearable={ clearable }
          classNamePrefix="typeahead"
          backspaceRemovesValue={ false }
          maxMenuHeight={200}
          placeholder=""
          aria-labelledby={ id }
          formatOptionLabel={ this.renderValue }
          loadOptions={ this.loadOptions } />}
          { GetIcon("triangle") }
        </div>
      </div>
    );
  }
}

export default TypeaheadFacet;

const { array, func, string } = PropTypes;

TypeaheadFacet.propTypes = {
  endpoint: string,
  handleFacetChange: func.isRequired,
  id: string.isRequired,
  label: string,
  selectedFacets: array.isRequired,
  values: array
};
